import React from 'react';
import SupplierDetail from './SupplierDetail';
import CompanyInfoDetail from './Detail';
import OnBoard from './OnBoard';
import { connect } from 'react-redux';
import { getSolarToken } from '@mpc/common/src/utils/vendorStorage';

const DetailsEntrance = (props: any) => {
    let token = getSolarToken();
    let oaNo = props.vendorProcessAudit?.oaNo;
    if(!props.vendorProcessAudit?.onboarded && (token || oaNo)){
        if(token){
            return <OnBoard {...props} solarToken={token}   />
        }
        if(oaNo){
            return <OnBoard {...props} oaNo={oaNo} />
            
        }
    }

    // return (
    //     <>
    //         {isNewSupplier ? <SupplierDetail {...props} /> : <CompanyInfoDetail {...props} />}
    //     </>
    // )

    // 老的供应商详情入口直接隐藏

    return <SupplierDetail {...props} />
}

const mapStateToProps = (state: any) => {
    return {
        account: state.account,
        suppliersList: state.account.suppliersList,
        vendorProcessAudit: state.account.vendorProcessAudit,
    }
}

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(DetailsEntrance);
